import React from "react";

const PartCategorySvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.842 9.65032L10.342 2.15033C10.042 1.85033 9.62532 1.66699 9.16699 1.66699H3.33366C2.41699 1.66699 1.66699 2.41699 1.66699 3.33366V9.16699C1.66699 9.62532 1.85033 10.042 2.15866 10.3503L9.65866 17.8503C9.95866 18.1503 10.3753 18.3337 10.8337 18.3337C11.292 18.3337 11.7087 18.1503 12.0087 17.842L17.842 12.0087C18.1503 11.7087 18.3337 11.292 18.3337 10.8337C18.3337 10.3753 18.142 9.95032 17.842 9.65032ZM10.8337 16.6753L3.33366 9.16699V3.33366H9.16699V3.32533L16.667 10.8253L10.8337 16.6753Z"
        fill="#006CDD"
      />
      <path
        d="M5.41699 6.66699C6.10735 6.66699 6.66699 6.10735 6.66699 5.41699C6.66699 4.72664 6.10735 4.16699 5.41699 4.16699C4.72664 4.16699 4.16699 4.72664 4.16699 5.41699C4.16699 6.10735 4.72664 6.66699 5.41699 6.66699Z"
        fill="#006CDD"
      />
    </svg>
  );
};

export default PartCategorySvg;
